import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './MobileMenu.css';

function MobileMenu({ username, onLogout, onManageAccounts, onManageTags, onSwitchUser }) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button className="mobile-menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
        <span className={`hamburger ${isOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>

      {isOpen && (
        <>
          <div className="mobile-menu-overlay" onClick={closeMenu} style={{ display: 'block' }}></div>
          <nav className="mobile-menu" style={{ display: 'flex' }}>
            <div className="mobile-menu-header">
              <h2>Menu</h2>
              <button className="mobile-menu-close" onClick={closeMenu} aria-label="Close menu">
                ×
              </button>
            </div>
            <div className="mobile-menu-links">
              <Link 
                to="/"
                className={isActive('/') ? 'active' : ''}
                onClick={closeMenu}
              >
                Home
              </Link>
              <Link
                to="/equity"
                className={isActive('/equity') ? 'active' : ''}
                onClick={closeMenu}
              >
                Equity
              </Link>
              <Link 
                to="/open-positions"
                className={isActive('/open-positions') ? 'active' : ''}
                onClick={closeMenu}
              >
                Open Positions
              </Link>
              <Link
                to="/trades"
                className={isActive('/trades') ? 'active' : ''}
                onClick={closeMenu}
              >
                Trades
              </Link>
              <Link
                to="/tasty"
                className={isActive('/tasty') ? 'active' : ''}
                onClick={closeMenu}
              >
                Tasty
              </Link>
              <Link
                to="/pmcc"
                className={isActive('/pmcc') ? 'active' : ''}
                onClick={closeMenu}
              >
                PMCC
              </Link>
              <Link
                to="/tools"
                className={isActive('/tools') ? 'active' : ''}
                onClick={closeMenu}
              >
                Tools
              </Link>
              <Link
                to="/tools/earnings"
                className={isActive('/tools/earnings') ? 'active' : ''}
                onClick={closeMenu}
              >
                Earnings
              </Link>
            </div>
            <div className="mobile-menu-footer">
              <div className="mobile-user-info">
                <span>Logged in as: <strong>{username}</strong></span>
              </div>
              <button className="mobile-menu-button" onClick={() => { closeMenu(); onManageAccounts(); }}>
                Settings
              </button>
              <button className="mobile-menu-button" onClick={() => { closeMenu(); onLogout(); }}>
                Logout
              </button>
            </div>
          </nav>
        </>
      )}
    </>
  );
}

export default MobileMenu;

